export enum DashboardPanel {
    GeneralInformation = 'general-information',
    Packs = 'packs',
    Profile = 'profile'
}